import React, { useEffect, useState } from "react";

import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import AgGridPaginatedTable from "../../component/AgGridPaginatedTable";
import ConditionalRenderer from "../../component/ConditionalRenderer";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteProjectAttachment,
  getDownloadProjectAttachmentsFile,
  getProjectAttachment,
  insertProjectAttachments,
} from "../../api/projectAttachment";
import { Controller, useForm } from "react-hook-form";
import { CloudUpload, Delete } from "@mui/icons-material";
import { projectAttachmentTable as tableDef } from "../../config/grid-columns-defs";
import { handleAxiosError } from "../../config/action-config";
import { showAlert } from "../../actions/alert";
import DeleteAlertDialog from "../../component/DeleteAlertDialog";
import {
  deleteActivitiesDocuments,
  getActivitiesDocuments,
  getDownloadActivitiesDocumentsFile,
  getDownloadActivitiesDocumentssFile,
  insertActivitiesDocuments,
  insertActivitiesDocumentss,
} from "../../api/activitiesDocuments";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export default function ActivitiesDocuments() {
  const location = useLocation();
  const user = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(-1);
  const dialogAction = useSelector((state) => state.dialog);
  const dispatch = useDispatch();
  const [itemDialog, setItemDialog] = useState(false);
  const params = useParams();
  const [activityName, setActivityName] = useState("");
  const navigate = useNavigate();

  async function loadMasterData(limit, offset) {
    try {
      const { data } = await getActivitiesDocuments(
        {
          activity_id: params.activityId,
          limit,
          offset,
        },
        user.token
      );
      if (data.data.ActivityAttachments.length) {
        setActivityName(data.data.ActivityAttachments[0].activity_name);
      } else {
        setActivityName("");
      }

      return {
        rows: data.data.ActivityAttachments,
        total: data.data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      //   setLoading(false);
    }
  }
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }
  const onItemDialogSubmit = async (formData, postData) => {
    try {
      const { data } = await insertActivitiesDocuments(
        formData,
        {
          activity_id: params.activityId,
          description: postData.description,
        },
        user.token
      );
      refreshTable();
      dispatch(showAlert(data.msg));
      setItemDialog(false);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };
  let document = tableDef.find((o) => o.headerName === "Document");
  let action = tableDef.find((o) => o.headerName === "Action");
  if (document === undefined) {
    tableDef.push({
      headerName: "Document",
      field: "file_name",
      resizable: true,
      minWidth: 180,
      cellClass: "pmt-ag-cell-font",
      cellRenderer: (params) => {
        const handleCellClick = async () => {
          setLoading(true); // Enable loading state before starting the action
          await getDocDownloadData(params.data.id);
        };

        return (
          <a href="#" onClick={handleCellClick}>
            {params.value}
          </a>
        );
      },
    });
  }
  if (action === undefined) {
    tableDef.unshift({
      headerName: "Action",
      field: "actions",
      resizable: true,
      wrapText: true,
      autoHeight: true,
      minWidth: 65,
      maxWidth: 70,
      headerClass: "justify-center",
      cellClass: "pmt-ag-cell-font justify-center",
      cellRendererFramework: (params) => (
        <IconButton
          color="info"
          onClick={() => {
            // console.log("ddddd", params?.data?.id);
            dispatch({ type: "DELETE", data: params.data });
          }}
        >
          <Delete fontSize="inherit" />
        </IconButton>
      ),
    });
  }
  const getDocDownloadData = async (id) => {
    if (loading) {
      return;
    }

    setLoading(true);

    try {
      const token = user.token;
      const blob = await getDownloadActivitiesDocumentsFile(id, token);
      const file = window.URL.createObjectURL(blob.data);
      setLoading(false);
      window.open(file, "_blank");
    } catch (err) {
      setLoading(false);
      handleAxiosError(err, dispatch);
    }
  };

  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "DELETE":
        setDeleteDialogOpen(true);
        break;

      default:
        break;
    }
  }, [dialogAction]);

  useEffect(() => {
    if (deleteId === -1) return;
    deleteActivitiesDocuments(deleteId, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setDeleteId(-1);
        refreshTable();
        setDeleteDialogOpen(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        setDeleteId(-1);
        setDeleteDialogOpen(false);
      });
  }, [deleteId]);
  // console.log("params---", location.state.activityName);
  return (
    <Box className="pmt-container-box">
      <Box className="pmt-title-box">
        <Box className="typography-title">
          <Typography variant="h1" className="pmt-headings-h1">
            {activityName} Documents
          </Typography>
        </Box>

        <Box sx={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
          <Button
            variant="contained"
            sx={{
              padding: "5px 7px",
              fontSize: { xs: "10px", sm: "12px" },
              marginRight: "10px",
            }}
            onClick={() => {
              navigate(-2);
            }}
            className="blue-button"
          >
            Go Back
          </Button>
          <Button
            variant="contained"
            sx={{
              padding: "5px 7px",
              fontSize: { xs: "10px", sm: "12px" },
            }}
            onClick={() => {
              setItemDialog(true);
            }}
            className="blue-button"
          >
            Add Document
          </Button>
        </Box>
      </Box>
      <br />
      <div>
        <AgGridPaginatedTable
          getTableRows={loadMasterData}
          columns={tableDef}
          perPage={10}
          refreshCounter={tableRefreshCount}
          // rowSelection="single"
          //   onRowClicked={(params) => {
          //     setSelectedEmployeeRow(params.data.ep_id);
          //   }}
        />
      </div>
      {loading && (
        <div className="overlay">
          <Loading></Loading>
        </div>
      )}
      <ItemDialogNoteTab
        open={itemDialog}
        setOpen={setItemDialog}
        onSubmit={onItemDialogSubmit}
      />
      <DeleteAlertDialog
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        setDeleteId={setDeleteId}
        rowId={dialogAction.data?.id}
      />
    </Box>
  );
}
const emptyItemData = {
  description: "",
};
function ItemDialogNoteTab({ open, setOpen, onSubmit }) {
  const user = useSelector((state) => state.user);
  const [loader, setLoader] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [isSelected, setIsSelected] = useState(false);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ defaultValues: emptyItemData });

  const submit = (data) => {
    const formData = new FormData();
    if (selectedFile == "") {
      setOpen("ATTACHMENTS_TAB");
      return dispatch(showAlert("Attachment can't be empty"));
    }
    const appenddata = formData.append("myFile", selectedFile);

    setLoader(true);
    onSubmit(formData, data).then(() => {
      setLoader(false);
      setIsSelected(false);
      setSelectedFile("");
    });
  };
  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
    setIsSelected(true);
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        // setOpen(false);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ textTransform: "capitalize" }}>
        Upload Attachment
      </DialogTitle>
      <DialogContent>
        <Grid container width={500} spacing={1} py={1}>
          <Grid item xs={12} sm={12} md={12}>
            <TextField
              type="text"
              label="Description"
              name="description"
              fullWidth
              multiline={true}
              rows={3}
              inputRef={register({
                required: "Description is required.",
              })}
              required
              error={Boolean(errors.description)}
              helperText={errors.description?.message}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Card sx={{ boxShadow: "none !important" }}>
              <div class="upload-files-container">
                <div class="drag-file-area">
                  <div class="upload-icon">
                    <CloudUpload sx={{ fontSize: 40, color: "#08459c" }} />
                  </div>
                  <h6 class="dynamic-message"> Drag & drop any file here </h6>
                  <div class="browse-files">
                    <input
                      className="file-upload"
                      type="file"
                      name="file"
                      onChange={changeHandler}
                    />
                    {isSelected ? (
                      <Box>
                        <Typography>Filename: {selectedFile.name}</Typography>
                        <Typography>Filetype: {selectedFile.type}</Typography>
                        <Typography>
                          Size in bytes: {selectedFile.size}
                        </Typography>
                        <Typography>
                          lastModifiedDate:{" "}
                          {selectedFile.lastModifiedDate.toLocaleDateString()}
                        </Typography>
                      </Box>
                    ) : (
                      <Typography>Select a file to show details</Typography>
                    )}
                  </div>
                </div>
              </div>
            </Card>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpen(false);
          }}
          className="cancel-button"
        >
          Cancel
        </Button>

        {loader ? (
          <div className="overlay">
            <Loading></Loading>
          </div>
        ) : (
          <Button
            disabled={/^Trial_User$/i.test(user.role) ? true : false}
            className="blue-button"
            onClick={handleSubmit(submit)}
          >
            {"Submit"}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

function Loading() {
  return (
    <div className="page d-flex">
      <div className="m-auto text-center">
        <CircularProgress />
      </div>
    </div>
  );
}
